export default "__VITE_ASSET__1918e685__"